<template>
  <!-- Content Left Rail -->
  <v-sheet class="settings-left-nav">
    <v-list-item-title class="settings-nav-title font-weight-medium"
      >Messages</v-list-item-title
    >
    <v-list dense nav>
      <v-list-item
        class="subtitle-1 left-nav"
        :class="routeColor('text-uniq-conv')"
        @click="navigateTo('text-uniq-conv')"
        v-if="$root.$children[0].isAdmin"
      >
        Unique Conversations
      </v-list-item>
      <v-list-item
        class="subtitle-1 left-nav"
        :class="routeColor('text-log')"
        @click="navigateTo('text-log')"
        v-if="$root.$children[0].isAdmin"
      >
        Message Log
      </v-list-item>
    </v-list>
  </v-sheet>
</template>

<script>
export default {
  name: "TextLeftNavigation",
  props: {
    msg: String
  },
  data: function() {
    return {
      toggleFilter: 1,
      selectedItem: null
    };
  },
  created() {},
  watch: {},
  computed: {},
  methods: {
    navigateTo(settingType) {
      this.$parent.$parent.$parent.settingsNavSelected = settingType;
      this.$root.$children[0].navMenuOpen = false;
    },
    routeColor(routeName) {
      return this.$parent.$parent.$parent.settingsNavSelected == routeName
        ? "font-weight-medium"
        : "font-weight-normal";
    }
  }
};
</script>

<style scoped lang="stylus">
.settings-left-nav {
  padding-top: 1rem;
}
div.settings-left-nav, div.settings-left-nav div {
  background-color: rgb(241, 241, 241);
  width: 100%;
}
.settings-left-nav div.v-list {
  padding: 0;
}
.settings-nav-title {
  padding: 1.5rem 2rem 0.5rem;
  font-size: 1.1rem;
  font-weight: 500;
  text-transform: uppercase;
}
.subtitle-1 {
  font-size: 1rem;
  font-weight: 400;
}
.v-list-item.left-nav {
  padding: .5rem 2rem;
}
</style>
